type ApiError = { code: string; message: string; reasons?: string[] }
export const isApiError = (err: any): err is ApiError => !!err?.code
